@if (formGroup()) {
  <ng-container body-content>
    <form [formGroup]="formGroup()">
      <app-international-mobile-phone></app-international-mobile-phone>
    </form>
  </ng-container>
  <div>
    <app-button
      theme="primary-v2"
      tid="confirm-button"
      tabindex="0"
      class="mt-4"
      (click)="submitChanges()"
      [loading]="isUpdatingMfaPreferences()"
      [disabled]="!formGroup()?.valid"
      [uppercaseText]="false"
      [buttonWidth]="'full'"
      [iconColor]="'white'"
      [fontColor]="'white'"
      [iconConfig]="{
        usePhosphorIcon: true,
        iconName: 'arrow-circle-right',
        outlined: false,
        hoverColor: 'white',
        size: 'small'
      }"
      buttonText="Register"
    >
    </app-button>
  </div>
}
